"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingForm = void 0;
var React = require("react");
var immer_1 = require("immer");
var stateless_forms_1 = require("../forms/stateless_forms");
var buttons_1 = require("../../buttons");
var generic_1 = require("../../generic");
var MapLayout_1 = require("../../admin/site_maps/map_layout/MapLayout");
var BookingLocationService_1 = require("../../../services/BookingLocationService");
var SiteMapLayerService_1 = require("../../../services/SiteMapLayerService");
var material_options = [
    ["beton", "beton"],
    ["gulve", "gulve"],
    ["ventilation", "ventilation"],
    ["stål", "stål"],
    ["lofter", "lofter"],
    ["tag", "tag"],
    ["mursten", "mursten"],
    ["fliser", "fliser"],
    ["andet", "andet"],
].sort();
function getNewBooking(location_options, contractor_options) {
    return {
        id: 0,
        resourceId: location_options.length > 0 ? location_options[0][0] : undefined,
        allDay: false,
        title: "New Booking",
        item: "",
        amount: 0,
        visitor: contractor_options.length > 0
            ? contractor_options[0][0]
            : undefined,
    };
}
var initial_booking = {
    id: undefined,
    resourceId: undefined,
    allDay: false,
    title: "",
    item: "",
    amount: 0,
    visitor: undefined,
};
var BookingForm = function (_a) {
    var booking = _a.booking, map_data = _a.map_data, location_data = _a.location_data, contractor_options = _a.contractor_options, bookingService = _a.bookingService, changeCurrentBooking = _a.changeCurrentBooking, isBookingValid = _a.isBookingValid, cancelNewBooking = _a.cancelNewBooking, user = _a.user, is_admin = _a.is_admin;
    var containerRef = React.useRef();
    var _b = __read(React.useState(false), 2), canceling = _b[0], setCanceling = _b[1];
    var open_locations = location_data.filter(function (location) { return location.status == BookingLocationService_1.LocationStatus.OPEN; });
    var location_options = open_locations.map(function (location) { return [location.id, location.name]; });
    var _c = __read(React.useState(initial_booking), 2), booking_data = _c[0], setBookingData = _c[1];
    React.useEffect(function () {
        setBookingData(booking || getNewBooking(location_options, contractor_options));
    }, [booking]);
    function updateField(name, value) {
        setBookingData((0, immer_1.default)(booking_data, function (draft) {
            draft[name] = value;
        }));
    }
    var can_edit = is_admin ||
        (booking_data && booking_data.visitor_user_id == user.id) ||
        booking == undefined;
    var booking_form_fields_1 = [
        {
            name: "resourceId",
            label: gettext("Location"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.SELECT,
            options: location_options,
            value: booking_data && booking_data.resourceId,
            required: true,
            disabled: !can_edit,
        },
    ];
    if (can_edit) {
        booking_form_fields_1.push({
            name: "visitor",
            label: gettext("Contractor"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.AUTOCOMPLETE,
            options: contractor_options,
            value: booking_data && booking_data.visitor,
            required: true,
            disabled: !can_edit,
        });
    }
    var booking_form_fields_2 = [
        {
            name: "start",
            label: booking_data.allDay ? gettext("Date") : gettext("Start"),
            field_type: booking_data.allDay
                ? stateless_forms_1.SimpleFormFieldTypes.DATE
                : stateless_forms_1.SimpleFormFieldTypes.DATETIME,
            value: booking_data.start,
            required: true,
            disabled: !can_edit,
        },
        {
            name: "end",
            label: gettext("End"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.DATETIME,
            value: booking_data.end,
            required: true,
            minDate: booking_data.start,
            maxDate: booking_data.start,
            disabled: !can_edit,
        },
        {
            name: "item",
            label: gettext("Material"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.SELECT,
            options: material_options,
            value: booking_data.item || "",
            disabled: !can_edit,
        },
        {
            name: "amount",
            label: gettext("Amount"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.NUMBER,
            value: booking_data.amount,
            disabled: !can_edit,
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement("div", { className: "row mt-2" },
                    React.createElement("div", { className: "col-6" },
                        React.createElement("h5", null, gettext("Booking Appointment"))),
                    booking && booking.visitor_phone && (React.createElement("div", { className: "col-6 text-right" },
                        React.createElement("h5", null,
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.phone, size: "sm", transform: { flipX: true } }),
                            " ",
                            React.createElement("span", { style: { color: "limegreen" } }, booking.visitor_phone))))),
                React.createElement("div", { className: "mb-2", style: { width: "100%", height: "300px" }, ref: containerRef },
                    React.createElement(MapLayout_1.MapLayout, { current_map: map_data, site_map_location_info: open_locations, setCurrentLocation: function (location_id) {
                            if (can_edit) {
                                updateField("resourceId", location_id);
                            }
                        }, allow_marker_drag: false, formatter: function (location) {
                            return {
                                icon_color: location.status == BookingLocationService_1.LocationStatus.OPEN
                                    ? "#599257"
                                    : "#a8051b",
                                font_size: 1.5,
                                icon_size: 0.25,
                                icon_type: SiteMapLayerService_1.default_layer_icon,
                            };
                        } })),
                React.createElement(stateless_forms_1.SimpleForm, { fields: booking_form_fields_1, onUpdate: function (name, value) {
                        if (can_edit)
                            updateField(name, value);
                    }, format: {
                        form_layout: stateless_forms_1.FormLayout.HORIZONTAL,
                        label_col: 3,
                    }, valuesObject: booking_data }),
                React.createElement(stateless_forms_1.SimpleForm, { fields: booking_form_fields_2, onUpdate: function (name, value) {
                        if (can_edit)
                            updateField(name, value);
                    }, format: {
                        form_layout: stateless_forms_1.FormLayout.VERTICAL,
                        form_grid_columns: 2,
                    }, valuesObject: booking_data }))),
        !canceling && (React.createElement("div", { className: "row" },
            React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", disabled: !can_edit || !isBookingValid(booking_data), onClick: function () {
                    if (booking_data.id) {
                        bookingService.update(booking_data, booking_data.id);
                    }
                    else {
                        bookingService.create(booking_data);
                    }
                    changeCurrentBooking(undefined);
                    cancelNewBooking();
                } }, gettext("Save Booking")),
            React.createElement(buttons_1.Button, { disabled: !can_edit, className: "gamification-sidebar-button", onClick: function () { return setCanceling(true); } }, gettext("Cancel Booking")))),
        canceling && (React.createElement("div", { className: "row" },
            React.createElement(buttons_1.AlertButton, { className: "gamification-sidebar-button", onClick: function () {
                    if (booking_data.id) {
                        bookingService.remove(booking_data.id);
                    }
                    else {
                        cancelNewBooking();
                    }
                    changeCurrentBooking(undefined);
                    setCanceling(false);
                } }, gettext("Yes, Cancel Booking")),
            React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () { return setCanceling(false); } }, gettext("No"))))));
};
exports.BookingForm = BookingForm;
